import React from 'react';

interface FormGroupProps {
  label: React.ReactNode;
  htmlFor: string;
  error?: string;
  children: React.ReactNode;
  labelCols?: string;
  inputCols?: string;
  labelAlign?: 'top' | 'middle';
}

export function FormGroup({ label, htmlFor, error, children, labelCols = 'col-sm-3', inputCols = 'col-sm-6', labelAlign = 'top' }: FormGroupProps) {
  const isMiddle = labelAlign === 'middle';
  return (
    <div className={`form-group${error ? ' has-error' : ''}`}>
      <div className="row" style={isMiddle ? { display: 'flex', alignItems: 'center' } : undefined}>
        <label className={`control-label ${labelCols}`} htmlFor={htmlFor}>{label}</label>
        <div className={inputCols}>
          {error && <span className="help-block">{error}</span>}
          {children}
        </div>
      </div>
    </div>
  );
}
